/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateTipDeclarationSettingsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {UpdateTipDeclarationSettingsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const updateTipDeclarationSettings = (request: UpdateTipDeclarationSettingsRequest, options?: CashRequestOptions) => post<UpdateTipDeclarationSettingsRequest, UpdateTipDeclarationSettingsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/UpdateTipDeclarationSettings", request, {...options, rejectOnError: true })